/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bitty": {
        "nested": {
          "ContentType": {
            "values": {
              "DO_NOT_USE_CT": 0,
              "FAQ": 1,
              "NEWS": 2
            }
          },
          "Content": {
            "fields": {
              "type": {
                "type": ".squareup.bitty.ContentType",
                "id": 1,
                "rule": "optional"
              },
              "title": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "body": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "imageUrl": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "button": {
                "type": ".squareup.bitty.Button",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "Button": {
            "fields": {
              "text": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "url": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bitty?.nested?.ContentType && !$root.nested?.squareup?.nested?.bitty?.nested?.Content && !$root.nested?.squareup?.nested?.bitty?.nested?.Button) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ContentType @ squareup/bitty/content.proto at 8:1
 */
export const ContentType = $root.lookupEnum('squareup.bitty.ContentType').values;
/**
 * SOURCE Content @ squareup/bitty/content.proto at 14:1
 */
export const Content = $root.lookupType('squareup.bitty.Content');
fixType(Content);
Builder.createAndAttachToType(Content);
/**
 * SOURCE Button @ squareup/bitty/content.proto at 26:1
 */
export const Button = $root.lookupType('squareup.bitty.Button');
fixType(Button);
Builder.createAndAttachToType(Button);